import { useState,useEffect } from "react";
import "./App.css";
export default function EmoryanAdventure() {

   
    


  const [tgUserId, setTgUserId] = useState(0);
    
      useEffect(() => {

        const tg = window.Telegram.WebApp;
        if(tg){
          const user = tg.initDataUnsafe?.user;
          if(user){
            setTgUserId(user.id)
          }
      
        }
      }, []);

    
  return (
    <div className="section" data-id={tgUserId}>
        {
            // (tgUserId == 6102230730  || tgUserId == 7186798577  || tgUserId == 7874266965) ? 
            (tgUserId !== 1000) ? 
            <>
            <iframe src="https://emoryanadventure.emorya.com/" style={{
                width:'100%',
                height:'100vh',
                borderWidth:0
                
            }} scrolling="no"  />
            </>:

            <>

<div
        className="gameScreen"
        style={{
          padding: 20,
          textAlign: "left",
          width: "100%",
          display: "flex",
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      ></div>
      <div
        style={{
          padding: 20,
          textAlign: "left",
          width: "100%",
          display: "flex",
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          zIndex: 20,
          flexDirection: "column",
        }}
        onClick={() => {
            global.openUrl("https://www.parxfit.com/emorya/game/fun/");
            global.changeSection('GAMES');
        }}
      >
        <img
          src={require("./assets/icon-square-3.png")}
          style={{
            width: "50%",
          }}
        ></img>
        
        <strong
          style={{
            fontSize: 20,
          }}
        >
          Click to play!
        </strong>
        <br />
        <div>
        <strong
          style={{
            fontSize: 25,
          }}
        >
        
        
        </strong>

      
      </div>
      </div>
            
            </>
        }
     
    </div>
  );
}
